import ListShop from "@/modules/promocodes/pages/shops/ListShop"
import ListShopLinks from "@/modules/promocodes/pages/shops/ListShopLinks"
import ListCouponNew from "@/modules/promocodes/pages/coupons/ListCouponNew"
import ListCouponDelete from "@/modules/promocodes/pages/coupons/ListCouponDelete"
import ListCouponCancel from "@/modules/promocodes/pages/coupons/ListCouponCancel"
import authMiddleware from "@/plugins/router/middlewares/auth"
import PostListShop from "@/modules/post/pages/posts/Promocode"

export default [
    {
        path: "/promocodes",
        name: "PromocodesListShop",
        component: ListShop,
        meta: {
            middleware: authMiddleware,
        }
    }, {
        path: "/promocodes/links",
        name: "PromocodesListShopLinks",
        component: ListShopLinks,
        meta: {
            middleware: authMiddleware,
        }
    }, {
        path: "/promocodes/coupons/new",
        name: "PromocodesListCouponNew",
        component: ListCouponNew,
        meta: {
            middleware: authMiddleware,
        },
    }, {
        path: "/promocodes/coupons/delete",
        name: "PromocodesListCouponDelete",
        component: ListCouponDelete,
        meta: {
            middleware: authMiddleware,
        },
    }, {
        path: "/promocodes/coupons/canceled",
        name: "PromocodesListCouponCancel",
        component: ListCouponCancel,
        meta: {
            middleware: authMiddleware,
        },
    }, {
        path: "/promocodes/posts/:channel_id(\\d+)",
        name: "PromocodesPostsShop",
        component: PostListShop,
        meta: {
            middleware: authMiddleware,
        }
    },
]
